import React, { useLayoutEffect, useState } from 'react'

import { AnswersBox } from './AnswersBox/AnswersBox'
import { ButtonBox } from './ButtonBox/ButtonBox'
import { QuestionText } from './QuestionText/QuestionText'
import { TaskDescription } from './TaskDescription/TaskDescription'

import { useAppDispatch, useAppSelector, useKeyDown } from 'common/hooks'
import { Task } from 'common/types/entities'
import { selectCurrentTaskNumber, selectResults, setTaskResult } from 'features/exam'

type PropsType = {
  tasks: Task[]
}

export const Question = ({ tasks }: PropsType) => {
  const dispatch = useAppDispatch()
  const currentTaskNumber = useAppSelector(selectCurrentTaskNumber)
  const results = useAppSelector(selectResults)

  const [selectedAnswers, setSelectedAnswers] = useState<string[]>([])

  const currentTask = tasks[currentTaskNumber]
  const isAnswered = results[currentTaskNumber].status !== null

  // useLayoutEffect - for correct keyboard navigation: 'Enter' keydown is used for both the answer-button and the next-button.
  // for block answer-button we need to reset selectedAnswers before button rendering
  useLayoutEffect(() => {
    setSelectedAnswers(results[currentTaskNumber].answers)
  }, [currentTaskNumber])

  const submitAnswerHandler = () => {
    if (!selectedAnswers.length) {
      return
    }

    dispatch(setTaskResult(selectedAnswers))
  }

  useKeyDown(submitAnswerHandler, 'Enter')

  return (
    <form onSubmit={submitAnswerHandler}>
      <QuestionText currentTask={currentTask} />
      <AnswersBox
        currentTask={currentTask}
        selectedAnswers={selectedAnswers}
        isAnswered={isAnswered}
        setSelectedAnswers={setSelectedAnswers}
      />

      <ButtonBox
        isAnswered={isAnswered}
        isSelectedAnswers={Boolean(selectedAnswers.length)}
        submitAnswerHandler={submitAnswerHandler}
      />
      {isAnswered && currentTask.descriptionMarkup && (
        <TaskDescription descriptionMarkup={currentTask.descriptionMarkup} />
      )}
    </form>
  )
}
